import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import FiltroDeBusca from './FiltroDeBusca.vue'
import { CamposDoFiltroDeBusca, obterFiltroDefault } from '@/shareds/sharedBusca'
import { authModule } from '@/store'


const __default__ = {
	inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ToolbarDaBusca',
  props: {
	buscando: { default: false, type: Boolean },
	filtro: { default: obterFiltroDefault, type: Object as PropType<CamposDoFiltroDeBusca> },
},
  emits: ["buscar", "limpar-busca"],
  setup(__props, { emit }: { emit: ({
	(e: 'buscar', filtro: CamposDoFiltroDeBusca): void
	(e: 'limpar-busca'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const formBusca = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

async function buscar(event?: InputEvent) {
	if (event) event.preventDefault()
	if (!formBusca.value!.validate()) return
	if (document.activeElement) (document.activeElement as HTMLInputElement).blur()
	emit('buscar', props.filtro)
}

return { __sfc: true,props, emit, formBusca, buscar, FiltroDeBusca, authModule }
}

})